import React, { useMemo, useState } from 'react';
import { ImageIcon } from 'lucide-react';

const TILE_SIZE_OPTIONS = [
  { id: 'small', label: 'Klein', min: 180 },
  { id: 'medium', label: 'Mittel', min: 230 },
  { id: 'large', label: 'Gross', min: 300 },
  { id: 'xlarge', label: 'Extra', min: 380 },
];

function validSize(value) {
  return TILE_SIZE_OPTIONS.some((option) => option.id === value) ? value : 'medium';
}

export function useMediaTileSize(storageKey) {
  const [value, setValue] = useState(() => {
    try {
      return validSize(window.localStorage.getItem(storageKey));
    } catch (e) {
      return 'medium';
    }
  });

  const update = (nextValue) => {
    const safeValue = validSize(nextValue);
    setValue(safeValue);
    try {
      window.localStorage.setItem(storageKey, safeValue);
    } catch (e) {
      // localStorage can be unavailable in strict browser modes.
    }
  };

  return [value, update];
}

export function getMediaGridStyle(tileSize) {
  const option = TILE_SIZE_OPTIONS.find((item) => item.id === tileSize) || TILE_SIZE_OPTIONS[1];
  return { gridTemplateColumns: `repeat(auto-fill, minmax(${option.min}px, 1fr))` };
}

export default function MediaViewControls({ value, onChange }) {
  const activeLabel = useMemo(
    () => TILE_SIZE_OPTIONS.find((option) => option.id === value)?.label || 'Mittel',
    [value]
  );

  return (
    <div className="flex flex-col sm:flex-row sm:items-center gap-2">
      <div className="inline-flex items-center gap-2 text-[12px] font-semibold text-[#5C5852]">
        <ImageIcon className="w-4 h-4 text-[#F26B1A]" />
        <span>Bildgroesse</span>
        <span className="sm:hidden text-[#1F1D1A]">({activeLabel})</span>
      </div>
      <div className="grid grid-cols-4 rounded-full border border-[#E5E0D2] bg-[#FAF8F2] p-1">
        {TILE_SIZE_OPTIONS.map((option) => (
          <button
            key={option.id}
            type="button"
            onClick={() => onChange(option.id)}
            className={`px-2.5 py-1.5 rounded-full text-[11px] font-semibold transition-colors ${
              value === option.id ? 'bg-[#F26B1A] text-white shadow-sm' : 'text-[#5C5852] hover:bg-white hover:text-[#F26B1A]'
            }`}
            title={`Bildgroesse: ${option.label}`}
          >
            {option.label}
          </button>
        ))}
      </div>
    </div>
  );
}
